import React, { Component } from "react";
import { Link } from "react-router-dom";
import 'bootstrap-icons/font/bootstrap-icons.css';
import heroImg from 'assets/funnel/lkw.png';
import buroRingLogo from 'assets/funnel/buro_ring.png';

class LkwLanding extends Component {

    componentDidMount() {
        document.title = "Wir suchen dich";
    }

    render() {
        return (
            <div className="d-flex flex-column min-vh-100 bg-white" style={{ maxWidth: 480, margin: '0 auto' }}>

                {/* Logo Header */}
                <div className="text-center py-3 border-bottom">
                    <img src={buroRingLogo} alt="Büroring Personalmanagement" style={{ height: 60, objectFit: 'contain' }} />
                </div>

                {/* Hero Banner */}
                <div className="position-relative overflow-hidden" style={{ height: 280, background: '#b0c4d4' }}>
                    <div
                        className="position-absolute top-0 start-0 h-100 d-flex flex-column justify-content-center p-4"
                        style={{ background: 'rgba(144,175,196,0.88)', width: '60%', clipPath: 'polygon(0 0, 90% 0, 68% 100%, 0 100%)' }}
                    >
                        <div className="d-flex align-items-center gap-1 mb-2">
                            <div
                                className="rounded-circle border border-danger d-flex align-items-center justify-content-center bg-white"
                                style={{ width: 22, height: 22, borderWidth: 3 }}
                            >
                                <div className="rounded-circle" style={{ width: 8, height: 8, background: '#dc3545' }} />
                            </div>
                            <span className="fw-bold text-dark" style={{ fontSize: 11 }}>büroring</span>
                        </div>
                        <div className="fw-bold text-white lh-1" style={{ fontSize: 28 }}>WIR SUCHEN</div>
                        <div className="fw-bold text-white lh-1" style={{ fontSize: 40 }}>DICH</div>
                    </div>
                    <img
                        src={heroImg}
                        alt=""
                        className="position-absolute top-0 end-0 h-100"
                        style={{ width: '50%', objectFit: 'cover', objectPosition: 'center top' }}
                    />
                </div>

                {/* Intro Text */}
                <div className="text-center px-4 py-4">
                    <p className="fs-5 fw-semibold text-dark mb-0">
                        Wir suchen Dich! Verstärke das Team unseres Kunden als:
                    </p>
                </div>

                {/* Job Details Card */}
                <div className="mx-3 mb-4">
                    <div className="card border-0 bg-light rounded-4 p-4 text-center">
                        <h2 className="fw-bold mb-0">LKW-Fahrer:in</h2>
                        <p className="text-muted mb-3">m/w/d</p>

                        <div className="mb-3">
                            <i className="bi bi-clock fs-4 text-dark" />
                            <div className="fw-semibold mt-1">Vollzeit - 40 Std.</div>
                            <div className="text-muted small">5 Tage-Woche</div>
                        </div>

                        <div className="mb-3">
                            <i className="bi bi-cash-stack fs-4 text-dark" />
                            <div className="fw-semibold mt-1">ab € 37.800,- Jahresbrutto zzgl. Tagegelder</div>
                            <div className="text-muted small">Natürlich zahlen wir je nach Qualifikation sowie Erfahrung auch gerne mehr!</div>
                        </div>

                        <div className="mb-3">
                            <i className="bi bi-calendar fs-4 text-dark" />
                            <div className="fw-semibold mt-1">ehestmöglich</div>
                        </div>

                        <div>
                            <i className="bi bi-geo-alt fs-4 text-dark" />
                            <div className="fw-semibold mt-1">8712 Niklasdorf</div>
                        </div>
                    </div>
                </div>

                {/* Quiz CTA Section */}
                <div className="text-center px-4 mb-2">
                    <h4 className="fw-bold mb-4">
                        Leg jetzt gleich direkt los und klick dich einfach &amp; schnell durch unser Bewerbungsquiz.
                    </h4>
                    <i className="bi bi-rocket text-secondary" style={{ fontSize: 52 }} />
                    <div className="mt-3">
                        <div className="fw-bold">In weniger als 60 Sekunden!</div>
                        <div className="fw-bold">Kein Lebenslauf notwendig!</div>
                    </div>
                </div>

                {/* CTA Buttons */}
                <div className="px-3 py-4 d-flex flex-column gap-3">
                    <Link
                        to={`/bueroring/lkw/quiz${this.props.location.search}`}
                        className="btn btn-danger py-3 rounded-3 fw-bold fs-5 mx-2"
                        style={{ boxShadow: '0 6px 20px rgba(220,53,69,0.4)', display: 'block' }}
                    >
                        <i className="bi bi-rocket-fill me-2" />
                        Lass uns direkt loslegen!
                    </Link>
                    <button
                        className="btn btn-outline-danger py-3 rounded-3 fw-bold fs-5 mx-2"
                        style={{ display: 'block' }}
                    >
                        <i className="bi bi-question-circle me-2" />
                        Mehr Infos bitte...
                    </button>
                </div>

                {/* Referral Section */}
                <div className="text-center px-4 py-4">
                    <h4 className="fw-bold">
                        Unser Job passt nicht zu dir, aber du kennst eine Person die super zu uns passen würde?
                    </h4>
                    <i className="bi bi-chat-dots text-secondary mt-3" style={{ fontSize: 52 }} />
                </div>

                {/* Footer */}
                <div className="mt-auto border-top px-4 py-4 text-center text-muted small">
                    <p className="mb-4">
                        Aus Gründen der Lesbarkeit wird auf dieser Website darauf verzichtet, durchgehend geschlechtsspezifische
                        Formulierungen zu verwenden. Soweit personenbezogene Bezeichnungen nur in männlicher Form angeführt sind,
                        beziehen sie sich auf Mann, Frau und Divers in gleicher Weise. Dies soll jedoch keinesfalls eine
                        Geschlechterdiskriminierung oder eine Verletzung des Gleichheitsgrundsatzes zum Ausdruck bringen.
                    </p>
                    <div className="fw-semibold text-dark">Powered by Ali_Christoph Enterprises</div>
                    <div className="text-muted mb-3">Ein Projekt von Ali_Christoph Enterprises</div>
                    <div className="d-flex justify-content-center gap-3 flex-wrap">
                        <a href="#" className="text-dark text-decoration-underline small">Impressum</a>
                        <a href="#" className="text-dark text-decoration-underline small">Clickmasters</a>
                        <a href="#" className="text-dark text-decoration-underline small">AGB</a>
                    </div>
                    <div className="mt-2">
                        <a href="#" className="text-dark text-decoration-underline small">Datenschutzerklärung</a>
                    </div>
                </div>

            </div>
        );
    }
}

export default LkwLanding;
